import {OtsDialog} from "../components/OtsDialog";
import type {OtsBrand, OtsColorSchemePreference} from "../theme/OtsTheme";
import {AttachmentManager, AttachmentManagerProps} from "./AttachmentManager";

export type AttachmentManagerDialogProps = AttachmentManagerProps & {
  open: boolean;
  onClose: () => void;
  brand?: OtsBrand;
  colorScheme?: OtsColorSchemePreference;
};

/** Dialog host for grids and other compact surfaces that cannot embed the full manager. */
export const AttachmentManagerDialog = ({
  open,
  onClose,
  brand,
  colorScheme,
  ...managerProps
}: AttachmentManagerDialogProps) => (
  <OtsDialog open={open} onClose={onClose} title="Manage attachments" size="4xl" compact={false}
    brand={brand} colorScheme={colorScheme}>
    <AttachmentManager {...managerProps}/>
  </OtsDialog>
);
